/**
 * Whether the atom→form sync should copy a leg's selection-atom amount into the form.
 *
 * Only an amount that moved on the atom since that effect last looked (`previous`), that the
 * account-normalization effect did not itself write there from the form (`formEchoes`), and
 * that differs from the form. The two effects run in one pass and the atom→form one reads the
 * atom a render behind, so copying on "atom ≠ form" alone swapped the two every render (the
 * unit-less atom held 100 USD one pass and 0.03656 ETH the next) until React bailed out.
 */
export function shouldCopyAtomAmount({
  atomAmount,
  previousAtomAmount,
  formEchoes,
  formAmount,
}: {
  atomAmount: string | undefined
  previousAtomAmount: string | undefined
  formEchoes: readonly string[] | undefined
  formAmount: string | undefined
}): boolean {
  if (!atomAmount) return false
  // No earlier sighting (first pass for this row, or its key just changed when its account was
  // normalized): this pass is the baseline, not a move. The row is already in the form, and
  // its amount got there through the add/append path.
  if (previousAtomAmount === undefined) return false
  if (atomAmount === previousAtomAmount) return false
  if (formEchoes?.includes(atomAmount)) return false
  return atomAmount !== formAmount
}
